export default __webpack_public_path__ + "images/a2a2698a475ef0860a6e47558ba0382a.png";